<template>
  <loader v-if="loading"></loader>
  <load-page-layout
    v-else
    :breadcrumbs="breadcrumbs"
    :cancel-button="true"
    :remove-button="$route.params.id !== 'new' && instance.permissions.delete"
    :edit-button="!editing && instance.permissions.update"
    :save-button="editing"
    remove-confirm-message="Vuoi veramente eliminare questa analisi?"
    @cancel="cancel"
    @remove="remove"
    @edit="edit"
    @save="save">
    <context-manager
      context="analyses"
      :context-id="instance.analysis.id"
      :permissions="instance.permissions"
      :workgroup-id="instance.analysis.workgroup.id"
      open
      v-if="instance" />
    <component
      :is="editorComponent"
      ref="editor"
      :value="instance"
      :errors="errors"
      :disabled="!editing"
      @input="instance = $event"
    />
    <debug-panel slot="debug">{{ instance }}</debug-panel>
  </load-page-layout>
</template>
<script>
import LoadPageMixin from 'vue-core/mixins/LoadPageMixin';

export default {
  mixins: [ LoadPageMixin ],

  computed: {
    breadcrumbs() {
      if (!this.instance) {
        return [];
      }

      return [
        {
          label: 'Home',
          link: '/protected'
        },
        {
          label: 'Analisi',
          link: '/protected/analyses'
        },
        {
          label: this.instance.analysis.title,
          link: '/protected/analyses/' + this.instance.analysis.id
        },
        {
          label: this.label,
          link: '/protected/analyses/' + this.instance.analysis.id + '/' + this.analysisType
        },
        {
          label: this.$route.params.id === 'new'
              ? '<Nuova>'
              : (this.instance && this.instance.title || '<Analisi>')
        }
      ];
    },
  },

  methods: {
    load() {
      console.log('Loading', this.$route);

      const analysisId = this.$route.params.analysisId;
      const originalId = this.$route.params.originalId;
      const id = this.$route.params.id;

      let prom;
      if (id === 'new') {
        prom = this.service.create({ analysisId });
      } else if (id === 'clone') {
        prom = this.service.clone({ analysisId, originalId });
      } else {
        prom = this.service.load({ analysisId, id });
      }

      this.loading = true;
      prom.then(this.onLoadSuccess, this.onLoadError);
    },

    save() {
      if (this.$refs.editor.dirtyInput) {
        const msg = 'ATTENZIONE: il software ha rilevato dei dati modificati. '
          + 'Procedendo al salvataggio senza effettuare una nuova analisi, '
          + 'i dati andranno persi. Sei sicuro di voler procedere?';

        if (!confirm(msg)) {
          return;
        }
      }

      if (this.$route.params.id !== 'new' && !this.$route.params.originalId) {
        this.update();
      } else {
        this.insert();
      }
    },

    insert() {
      const analysisId = this.$route.params.originalId
          ? this.instance.analysis.id
          : this.$route.params.analysisId;
      const instance = this.instance;

      this.loading = true;
      this.errors = null;
      this.service.insert({ analysisId, instance })
          .then(this.onInsertSuccess, this.onInsertError);
    },

    onInsertSuccess({ statusCode, data}) {
      console.log('Insert success', data);
      const newRoute = {
        name: this.$route.name.replace('Clone', ''),
        params: {
          analysisId: data.analysis.id,
          id: data.id,
        }
      };
      console.log('newRoute', newRoute);
      this.$router.push(newRoute);
    },

    update() {
      const analysisId = this.$route.params.analysisId;
      const id = this.$route.params.id;
      const instance = this.instance;

      this.loading = true;
      this.errors = null;
      this.service.update({ analysisId, id, instance })
          .then(this.onUpdateSuccess, this.onUpdateError);
    },

    cancel() {
      if (!this.instance.id || !this.editing) {
        this.$router.push({
          name: this.findPage
        });
      } else {
        this.unedit();
      }
    },

    remove() {
      const analysisId = this.$route.params.analysisId;
      const id = this.$route.params.id;

      this.loading = true;
      this.service.remove({ analysisId, id })
          .then(this.onRemoveSuccess, this.onRemoveError);
    },

    onRemoveSuccess({ statusCode, data}) {
      this.$router.push({
        name: this.findPage
      });
    },
  }
};
</script>
